const loginAndSignUp = {
  loginTips: 'Vous avez déjà un compte HitPaw ? <1>Connectez</1>',
  loginSuccessTips: 'Connexion réussie',
  loginErrorTips: 'Échec de la connexion',
  loginAccountOrPasswordErrorTips:
    "L'adresse e-mail ou mot de passe erroné, veuillez le saisir à nouveau.",
  loginAccountNotExitErrorTips: "L'adresse e-mail n'est pas enregistrée",
  signUpTips: "Vous n'êtes pas encore inscrit ? ",
  rememberMe: 'Mémorisez votre mot de passe',
  forgotPassword: 'Mot de passe oublié?',
  forgotPasswordTitle: 'Cliquez Oublier le mot de passe',
  verifyEmailBtn: "Vérifier l'e-mail",
  resetPasswordTitle: 'Réinitialiser le mot de passe',
  resetPasswordLabel: 'Veuillez réinitialiser votre mot de passe',
  resetPasswordPlaceholder: 'Entrez le nouveau mot de passe',
  resetPasswordSuccessTips: 'Réinitialisation du mot de passe réussie',
  signUpPrivacyTips:
    "En vous inscrivant, vous acceptez l'<1>Utilisation de nos Services</1> et notre <3>Politique de Confidentialité</3>",
  loginPrivacyTips:
    "En vous connectant, vous acceptez l'<1>Utilisation de nos Services</1> et notre <3>Politique de Confidentialité</3>",
  signUpSuccessTips: 'Votre compte a été enregistré avec succès !',
  getCode: 'Obtenir le code ',
  getCodeSuccessTips:
    'Il a été envoyé à votre adresse électronique, veuillez le vérifier.',
  verificationSuccessTips: 'Vérification de la boîte aux lettres réussie',
  surveyTitle: 'Bienvenue HitPaw en Ligne',
  surveyStep1: '<1>Étape 1</1>/3',
  surveyStep2: '<1>Étape 2</1>/3',
  surveyStep3: '<1>Étape 3</1>/3',
  surveyQuestion: 'Pourquoi utilisez-vous HitPaw ?',
  surveyThemeQuestion: 'Choisissez votre mode préféré',
  surveyAnswerOther: 'Les Autres',
  surveyAnswer1: 'Vidéos de Tous les Jours',
  surveyAnswer2: 'Vidéos Commerciales',
  surveyAnswer3: "Vidéos d'Entreprise",
  surveyAnswer4: 'Vidéos de Marketing',
  surveyAnswer5: 'Vidéos sur les Réseaux Sociaux',
  surveyAnswer6: 'Diaporamas Vidéos',
  surveyAnswer7: 'Outils Vidéos',
  surveyAnswer8: 'Vidéos de Voyage',
  surveyAnswer9: 'Vidéos de Mariage',
  surveyAnswer10: "Vidéos d'Anniversaire",
  surveyAnswer11: 'Vidéos sur les Bébés',
  surveyAnswer12: "Vidéos d'Animaux",
  surveyAnswer13: "Vidéos sur l'Alimentation",
  surveyAnswer14: 'Vidéos de Mode',
  surveyAnswer15: 'Vidéos de Vacances',
  surveyAnswer16: 'Vidéos sur le Sport',
  surveyAnswer17: 'Vidéos Photos',
  surveyAnswer18: 'Vidéos de Musique',
  surveyAnswerLightMode: "Mode d'Éclairage",
  surveyAnswerDarkMode: 'Mode Sombre',
  surveyNextBtn: 'Continuer',
  surveyBackBtn: 'Retour',
  surveyDoneBtn: 'Terminé',
  surveyStartBtn: 'Commencez',
  logoutWarnTips: 'Vous êtes sûr de vouloir vous déconnecter ?',
  ContinuewithGoogle: 'Continuer avec Google',
  Securityverification: 'Vérification de la sécurité',
  youraccount: 'Votre compte',
  alreadyexiststoensurethesecuritypleaseverifyitfirst:
    'existe déjà, veuillez vérifier.',
};

export default loginAndSignUp;
